module.exports = __webpack_public_path__ + "img/align-right.eb8bc2d5.svg";